module.exports = __webpack_public_path__ + "img/img-119.a91516c1.png";